import React from "react";
import styled from "styled-components";
import BinIcon from "../Icons/BinIcon";
import ConnectedIcon from "../Icons/ConnectedIcon";
import DoneIcon from "../Icons/DoneIcon";
import { PlayerCell } from "./Common/Table";
import LightningIcon from "Icons/LightningIcon";

const Container = styled.span<{ showIcons: boolean }>`
  height: 1em;
  align-items: center;
  display: flex;
  position: relative;
  padding: 0.5em 0;
  margin: 0.2em 0;
  ${({ showIcons }) =>
    showIcons &&
    `
  padding: 0.5em;
  `}
`;

const LightningIconContainer = styled.span`
  position: absolute;
  top: 0em;
  left: -2em;
  color: yellow;
`;
const DoneIconContainer = styled.span`
  position: absolute;
  top: 1.1em;
  left: -0.8em;
`;
const ConnectedIconContainer = styled.span`
  position: absolute;
  top: 0em;
  left: -0.8em;
`;
const BinIconContainer = styled.span`
  position: absolute;
  top: 0.5em;
  right: 0em;
`;

interface PlayerNameProps {
  name?: string;
  handleOnRemovePlayer?: () => void;
  isConnected: boolean;
  isReady?: boolean;
  showIcons?: boolean;
  finishedFirst?: boolean;
}

const PlayerName = ({
  name,
  handleOnRemovePlayer,
  isConnected,
  isReady,
  showIcons = false,
  finishedFirst = false,
}: PlayerNameProps) => (
  <>
    <Container showIcons={showIcons}>
      {showIcons && finishedFirst && (
        <LightningIconContainer>
          <LightningIcon />
        </LightningIconContainer>
      )}
      {showIcons && (
        <>
          <DoneIconContainer>
            <DoneIcon show={isReady ?? false} />
          </DoneIconContainer>
          <ConnectedIconContainer>
            <ConnectedIcon isConnected={isConnected} />
          </ConnectedIconContainer>
        </>
      )}
      <PlayerCell>{name}</PlayerCell>
      {showIcons && !isConnected && handleOnRemovePlayer && (
        <BinIconContainer>
          <BinIcon handleOnRemovePlayer={handleOnRemovePlayer} />
        </BinIconContainer>
      )}
    </Container>
  </>
);
export default PlayerName;
